import React from 'react';
import './App.css';
import './i18n';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import MaintenanceModal from './components/MaintenanceModal';
import AccessibilityWidget from './components/AccessibilityWidget';
import MatomoTracker from './components/MatomoTracker';
import Home from './pages/Home';
import Tableau from './pages/Tableau';
import TrainDetail from './pages/TrainDetail';
import Admin from './pages/Admin';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import CGU from './pages/CGU';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <BrowserRouter>
        <MatomoTracker />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tableau" element={<Tableau />} />
            <Route path="/train/:vjId" element={<TrainDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/cgu" element={<CGU />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <MaintenanceModal />
        <AccessibilityWidget />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
